

window.addToCartById = async function (variantId) {
  if (!variantId) return;

  try {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const body = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname,
    };

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error('Item could not be added!');
    }

    const data = await response.json();
    console.log('product added', data);

    cartDrawer.renderContents(data);
    cartDrawer.classList.remove('is-empty');
    cartDrawer.open();
  } catch (error) {
    console.log('something went wrong', error);
  }
}